import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandDialog, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";
import { api } from "../lib/api";
import { NAV } from "../lib/nav";
import { HELP, tabsFor } from "../lib/bookTabs";
import { useCurrentBook } from "../lib/currentBook";
import { useAuth } from "../context/AuthContext";

export function QuickSearch() {
  const [open, setOpen] = useState(false);
  const [books, setBooks] = useState([]);
  const nav = useNavigate();
  const { user } = useAuth();
  const cur = useCurrentBook();
  useEffect(() => {
    const key = (e) => { if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); } };
    const ev = () => setOpen(true);
    window.addEventListener("keydown", key); window.addEventListener("open-search", ev);
    return () => { window.removeEventListener("keydown", key); window.removeEventListener("open-search", ev); };
  }, []);
  useEffect(() => { if (open) api.get("/books").then((r) => setBooks(r.data)).catch(() => {}); }, [open]);
  const go = (to) => { setOpen(false); nav(to); };
  const isAdmin = ["owner", "admin"].includes(user?.role);
  return (
    <CommandDialog open={open} onOpenChange={setOpen}>
      <CommandInput placeholder="Search books, tools and pages…" data-testid="quick-search-input" />
      <CommandList data-testid="quick-search-list">
        <CommandEmpty>Nothing found.</CommandEmpty>
        {cur && (
          <CommandGroup heading={`In “${cur.title}”`}>
            {tabsFor(cur.format).map(([k, l]) => <CommandItem key={k} value={`tab ${l}`} onSelect={() => go(`/app/books/${cur.id}?tab=${k}`)} data-testid={`qs-tab-${k}`}>{l}<span className="ml-2 text-[11px] text-slate-500 truncate">{HELP[k]}</span></CommandItem>)}
          </CommandGroup>
        )}
        <CommandGroup heading="Your projects">
          {books.slice(0, 50).map((b) => <CommandItem key={b.id} value={`book ${b.title} ${b.author || ""}`} onSelect={() => go(`/app/books/${b.id}`)} data-testid={`qs-book-${b.id}`}>{b.title}<span className="ml-2 text-[11px] text-slate-500">{b.format || "novel"}</span></CommandItem>)}
        </CommandGroup>
        <CommandGroup heading="Pages">
          {NAV.filter((n) => (!n.admin || isAdmin) && (!n.owner || user?.role === "owner")).map((n) => <CommandItem key={n.id} value={`page ${n.label}`} onSelect={() => go(n.to)} data-testid={`qs-page-${n.id}`}><n.icon size={14} className="mr-2" />{n.label}</CommandItem>)}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
